import { buildCancelRequestSubject } from "../../../libs/models/cs/cancelRequestSubject";
import type { MailDraft } from "../components/mailDraft";
import { CONTACT_SUPPORT_EMAIL } from "./contactMailto";

/**
 * キャンセル依頼のメールの下書き。件名に `【キャンセルリクエスト S12345】` を入れる。件名の文字列で
 * 機械的にキャンセル依頼と判定して出荷を止めるので、お客様に打ってもらわずにこちらで作ってコピーしてもらう。
 *
 * 本文にはキャンセルの理由と、ご本人を確認するための項目 (お問い合わせの雛形と同じ) の記入欄を置く。
 * 注文時と違うアドレスから届くと送信元で注文を確かめられないので、氏名・電話番号で照合する。
 *
 * 本文の区切りは見出し (【…】) で表す。罫線を使うと /cs のタイムラインの引用・署名トリムが境界と
 * 誤認して、その下の記入を隠してしまう。
 */
export const buildCancelRequestMail = (orderCode: string): MailDraft => {
  const code = orderCode.replace(/^#/, "");
  const body = [
    "【キャンセルの理由】(必須)",
    "※ この下にご記入ください。ご記入がない場合は、キャンセルのご依頼をお受けできません。",
    "",
    "",
    "【ご注文情報】",
    `注文番号: ${code}`,
    "ご氏名 (フルネーム):",
    "ご注文時のメールアドレス:",
    "お電話番号:",
  ].join("\n");
  return { to: CONTACT_SUPPORT_EMAIL, subject: buildCancelRequestSubject(code), body };
};
